// src/services/api.js - Correction de l'import jwt-decode
import axios from 'axios';
import { jwtDecode } from "jwt-decode";


// URL de base de l'API
const API_URL = 'https://api.taply.pro/api';

// Créer une instance axios avec une configuration de base
const api = axios.create({
  baseURL: API_URL,
});

// Intercepteur pour ajouter le token d'authentification aux requêtes
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      
      // Vérifier si le token est expiré
      const decodedToken = jwtDecode(token);

      const currentTime = Date.now() / 1000;
      
      if (decodedToken.exp < currentTime) {
        // Token expiré, déconnecter l'utilisateur
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/admin/login';
        return Promise.reject('Session expirée. Veuillez vous reconnecter.');
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les réponses et les erreurs
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Gérer les erreurs d'authentification (401)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Rediriger vers la page de connexion si l'utilisateur n'est pas sur cette page
      if (window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;